import React, {useEffect} from 'react';
import "./home.css";

import Aos from 'aos';
import 'aos/dist/aos.css';

const Home = () => {

  useEffect(()=>{
    Aos.init({duration:2000});
  },[])


  return (
    <div id='Home'>
      <section className='home'>
        <div className="secContainer container">
          <div className="homeText">
            <h1 data-aos="fade-up" className="title">
              Plan Your Trip With Happy Safar!
            </h1>
            <p data-aos="fade-up" data-aos-duration="2500" className="subTitle">
              Travel to your favourite city with Happy Safar and make memories that will last a lifetime.
            </p>
            <button data-aos="fade-up" data-aos-duration="3000" className="btn">
              <a href='#Offers'>Explore Now</a>
            </button>
            <div className="homeCard grid" >
              <div data-aos="fade-right" data-aos-duration="2000" className="locationDiv">
                <label htmlFor="location">Location</label>
                <input type="text" placeholder='Drem Destination'/>
              </div>
              <div data-aos="fade-right" data-aos-duration="2500" className="distDiv">
                <label htmlFor="distance">Distance</label>
                <input type="text" placeholder='11 Metres'/>
              </div>
              <div data-aos="fade-right" data-aos-duration="3000" className="priceDiv">
                <label htmlFor="price">Price</label>
                <input type="text" placeholder='300 DH - 1500 DH'/>
              </div>
              <div data-aos="fade-left" data-aos-duration="2000" className="btnDiv">
                  <button className='btnCard btn'>Search</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home